import { CheckSquare } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { jiraWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  jiraWeb,
  {
    JiraPage: () => import('./JiraPage'),
    JiraAssociationChip: () => import('./JiraAssociationChip'),
    JiraIssueContextProvider: () => import('./JiraIssueContextProvider'),
  },
  {
    icons: { CheckSquare },
  },
);
